var map = {
	"./1AGP.png": 50761,
	"./2AGP.png": 87764,
	"./3AGP.png": 82354,
	"components/Catalog/AGP/img/glass/t/tPlusGold/1AGP.png": 50761,
	"components/Catalog/AGP/img/glass/t/tPlusGold/2AGP.png": 87764,
	"components/Catalog/AGP/img/glass/t/tPlusGold/3AGP.png": 82354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13107;